// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1QnyO","content":"LoadingAlert_content__ZLe3y"};